export class AddCategoryModel {
    CategoryName: string;
    SearchTags: string;
}

export class UpdateCategoryModel {
    Id: string;
    CategoryName: string;
    SearchTags: string;
    IsActive: string;
}

export class CategoryResponseModel {
    Id: string;
    categoryName: string;
    searchTags: string;
    isActiveValue: string;
}
